import { render, staticRenderFns } from "./NoClient.vue?vue&type=template&id=96d93fd8&"
import script from "./NoClient.vue?vue&type=script&lang=js&"
export * from "./NoClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports